<template>
    <table class="property-summary-details">
        <tbody>
            <tr>
                <td v-if="dpp.propertyTypeDisplay">
                    <i v-bind:class="['icon-year-built', dpp.propertyTypeIcon]"></i>
                    <div class="content">
                        <span v-if="dpp.isNewDpp">Property type</span>
                        <span>{{ dpp.propertyTypeDisplay }}</span>
                    </div>
                </td>

                <td v-if="dpp.geo.neighborhood">
                    <i class="icon-user-group"></i>
                    <div class="content">
                        <span v-if="dpp.isNewDpp">{{molang('dpp.propertyDetails.neighborhood')}}</span>
                        <button type="button" class="link" v-scroll="'propertyMapPanel'">
                            {{dpp.geo.neighborhood}}
                        </button>
                    </div>
                </td>
                <td v-if="dpp.yearBuilt > 0">
                    <i class="icon-year-built"></i>
                    <div class="content">
                        <span v-if="dpp.isNewDpp">Year built</span>
                        <span>
                            <span v-if="!dpp.isNewDpp">{{molang('dpp.propertyDetails.yearBuilt')}} {{molang('dpp.propertyDetails.in')}} </span>{{ dpp.yearBuilt }}
                        </span>
                    </div>
                </td>
                <td v-if="dpp.rdcMoveinReady !== undefined">
                    <i class="icon-box"></i>
                    <div class="content">
                        <span v-if="dpp.isNewDpp">Move-in ready?</span>
                        <span>
                            <span>{{dpp.rdcMoveinReady === false ? 'No - To be built' : 'Yes'}}</span>
                        </span>
                    </div>
                </td>
                <td>
                    <i class="icon-cash"></i>
                    <div class="content">
                        <span v-if="dpp.isNewDpp">HOA fee</span>
                        <span>
                            <span v-if="!dpp.isNewDpp">{{molang('dpp.propertyDetails.hoa')}} </span>{{dpp.hoafee ? $filters.formatPrice(dpp.hoafee) : '$0'}}{{perHOAUnit()}}
                        </span>
                    </div>
                </td>

                <td v-if="dpp.lotSize">
                    <i class="icon-property-lot"></i>
                    <div class="content">
                        <span v-if="dpp.isNewDpp">Lot size</span>
                        <span>
                            {{$filters.formatFriendlyLotSize(dpp.lotSize, dpp.lotSizeUnit)}}<span v-if="!dpp.isNewDpp"> {{molang('dpp.propertyDetails.lot')}}</span>
                        </span>
                    </div>
                </td>

                <td v-if="getEstimatePriceRange">
                    <button type="button" @click="openDisclaimer" aria-label="Learn about the Movoto estimate"><i class="icon-logo-m-new"></i></button>
                    <div class="content">
                        <span v-if="dpp.isNewDpp">Movoto estimate</span>
                        <button type="button" class="link" v-scroll="'propertyEstimatePanel'">
                            <span v-if="!dpp.isNewDpp">Est: </span>{{getEstimatePriceRange}}
                        </button>
                    </div>
                </td>

                <td v-if="dpp.garage > 0">
                    <i class="icon-parking"></i>
                    <div class="content">
                        <span v-if="dpp.isNewDpp">Parking</span>
                        <span>
                            {{ dpp.garage}} <span v-if="dpp.isNewDpp">garage spaces</span>
                            <span v-if="!dpp.isNewDpp"> {{molang('dpp.propertyDetails.garageSpaces')}}</span>
                        </span>
                    </div>
                </td>

                <td v-if="getEstRentFee && getEstRentFee.value && !hideEstMonthCost">
                    <i class="icon-investment"></i>
                    <div class="content">
                        <span>Rental estimate</span>
                        <b type="button" class="link" v-scroll="'propertyEstimatePanel'" role="button">{{$filters.formatPrice(getEstRentFee.value)}}/Month</b>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</template>
<script src="./property-summarydetails.js"></script>
<style lang="scss">
@use './property-summarydetails.scss' as *;
</style>

